
import ImageText from "../components/ImageText";

export const LandingPage = () => {
    return <div data-testid="LandingPage">
        <ImageText />
    </div>
}

export default LandingPage